// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".claimErrorMsgs,.showErrorMsgs{padding-left:30px}.showErrorMsgs{color:red!important}", ""]);
// Exports
module.exports = exports;
